import { render, staticRenderFns } from "./PlayerSynopsis.vue?vue&type=template&id=32803ed4"
import script from "./PlayerSynopsis.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayerSynopsis.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports